import type { ThemeVisualPair } from "../types"

export const pair = (fill: string, stroke: string): ThemeVisualPair => ({ fill, stroke })

export const sharedTokens = {
  "--theme-radius": "0px",
  "--theme-border-width": "1px",
  "--theme-shadow-opacity": "0.06",
  "--theme-font-sans": "'Geist', 'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif",
  "--theme-font-mono": "'Geist Mono', 'IBM Plex Mono', ui-monospace, 'SF Mono', monospace",
  "--theme-font-heading": "'Geist', 'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif",
  "--font-label": "var(--theme-font-sans)",
  // Motion tokens
  "--motion-fast": "100ms",
  "--motion-normal": "200ms",
  "--motion-slow": "400ms",
  "--easing-default": "cubic-bezier(0.4, 0, 0.2, 1)",
  "--easing-emphasized": "cubic-bezier(0.2, 0, 0, 1)",
  // Radius tokens
  "--radius-none": "0",
  "--radius-xs": "2px",
  "--radius-sm": "4px",
  "--radius-md": "6px",
}
